/**
 * Plain text display helper.
 *
 * This component used to blur sensitive values until tapped. The user explicitly
 * asked to remove masking / click-to-reveal entirely (task-31), so `value` is now
 * always rendered directly. The old props are kept as ignored compatibility
 * parameters so existing call sites do not need churn.
 */
export interface MaskedTextProps {
  value: string;
  label?: string;
  className?: string;
  multiline?: boolean;
  /** @deprecated Ignored: masking was removed (task-31). */
  forceMask?: boolean;
  /** @deprecated Ignored: masking was removed (task-31). */
  visibleStart?: number;
  /** @deprecated Ignored: masking was removed (task-31). */
  visibleEnd?: number;
}

export function MaskedText({
  value,
  label,
  className = '',
  multiline = false,
  // Accepted for API compatibility only; values are always shown directly.
  forceMask: _forceMask,
  visibleStart: _visibleStart,
  visibleEnd: _visibleEnd,
}: MaskedTextProps) {
  if (!value) return null;
  return (
    <span className={multiline ? `whitespace-pre-wrap break-words ${className}` : className}>
      {label ? <span className="mr-1 text-slate-500">{label}</span> : null}
      {value}
    </span>
  );
}
